import { computed } from "nanostores";

import { getExtensionPolicy, listExtensionPolicies } from "../api";
import { createApiStore } from "./api-store";
import { createPaginationStore } from "./pagination.ts";
import { $router } from "./router";

export const $extensionPoliciesPagination = createPaginationStore();

/** Load all policies once; the list page paginates the merged view client-side. */
const ALL_POLICIES_PAGE_SIZE = 10_000;

export const $extensionPoliciesList = createApiStore(listExtensionPolicies, {
  mapToOptions: () => ({
    query: {
      currentPage: 1,
      pageSize: ALL_POLICIES_PAGE_SIZE,
    },
  }),
  params: [computed($router, (route) => String(route?.route))],
  storeKey: "extensionPoliciesList",
});

export const $extensionPolicyContent = createApiStore(getExtensionPolicy, {
  mapToOptions: ([policyId]) => ({
    path: { id: Number.parseInt(policyId ?? "", 10) },
  }),
  params: [
    computed($router, (router) => {
      if (router?.route !== "extensionPoliciesEdit") return null;
      return router.params.policyId;
    }),
  ],
  storeKey: "extensionPolicyContent",
});
